import { FaHeart, FaChurch, FaHandsHelping as FaSkills } from 'react-icons/fa';
import { motion } from 'framer-motion';
import PayPalDonateButton from './PayPalDonateButton';
import DonateNow from './PayPalDonateButton';


const GetInvolved = () => {
   

    const handlePrayerClick = () => {
        const subject = "Prayer Request";
        const body = "Dear Life Missions Ministry,\n\nI would like to submit the following prayer request:\n\n[Please type your prayer request here]\n\nThank you,\n[Your Name]";
        window.open(`mailto:info@lifemissionsministry.org?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`);
    };

    return (
        <section className="py-2 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                    className="mb-16"
                >
                    <h2 className="text-3xl font-bold text-center text-indigo-900 mb-12">Get Involved</h2>
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-2">
                        <div className="bg-white p-8 rounded-xl shadow-md">
                            <div className="bg-indigo-100 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                                <FaChurch className="text-indigo-700 text-2xl" />
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-4">Prayer Partnership</h3>
                            <p className="text-gray-600 mb-4">Join one of our short-term mission teams and serve alongside our ministry.</p>
                            <button
                                onClick={() => handlePrayerClick()}
                                className="text-indigo-700 font-medium hover:underline"
                            >
                                Learn More →
                            </button>
                        </div>
                        <div className="bg-white p-8 rounded-xl shadow-md">
                            <div className="bg-indigo-100 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                                <FaHeart className="text-indigo-700 text-2xl" />
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-4">Financial Support</h3>
                            <p className="text-gray-600 mb-4">Connect your church with our ministry for long-term impact.</p>
                            {/* <div className="mt-4">
                                <PayPalDonateButton
                                    buttonId="T2AM83P2K5S4U"
                                />
                            </div> */}
                        </div>
                        <div className="bg-white p-8 rounded-xl shadow-md">
                            <div className="bg-indigo-100 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                                <FaSkills className="text-indigo-700 text-2xl" />
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-4">Volunteering with us</h3>
                            <p className="text-gray-600 mb-4">Offer your professional skills to support our operations and programs.</p>
                            <button
                                onClick={() => handlePrayerClick()}
                                className="text-indigo-700 font-medium hover:underline"
                            >
                                Share Your Skills →
                            </button>
                        </div>

                        <div className="bg-white p-8 rounded-xl shadow-md">
                            <div className="bg-indigo-100 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                                <FaSkills className="text-indigo-700 text-2xl" />
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-4">Sponsoring a child, widow, or pastor</h3>
                            <p className="text-gray-600 mb-1">Offer your professional skills to support our operations and programs.</p>
                            {/* <div className="mt-4">
                                <PayPalDonateButton
                                    buttonId="8GKG36YW2CBDN"
                                />
                            </div> */}
                        </div>
                    </div>

                    <div className="mt-8 text-center">
                        <DonateNow/>
                    </div>
                </motion.div>
                {/* Call to Action */}
                <motion.section
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                    className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-4 text-center"
                >
                    <div className="bg-gradient-to-r from-blue-900 to-blue-500 rounded-2xl p-12 shadow-2xl">
                        <h2 className="text-3xl font-bold text-white mb-6 font-serif">Join Us in This Kingdom Work</h2>
                        <p className="text-blue-100 text-xl mb-8 max-w-3xl mx-auto">
                            Whether through prayer, giving, or going, you can be part of what God is doing through Life Missions Ministry.
                        </p>
                        <motion.button
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            className="bg-white text-blue-700 hover:bg-blue-50 font-bold py-4 px-10 rounded-full transition-colors duration-300 text-lg shadow-lg"
                        >
                            Get Involved
                        </motion.button>
                    </div>
                </motion.section>
            </div>
        </section>
    );
};

export default GetInvolved;